import { Skeleton, TextField } from '@mui/material';
import { DEAL_PERMITTED_STAGES } from 'common/constants/analyst-dashboards';
import { DealStageState } from 'dashboard409a/pages/Operations/components/ValuationDealInfo/ValuationDealInfo.props';
import { StyledAutocomplete, StyledBadge } from 'dashboard409a/pages/Operations/components/ValuationDealInfo/ValuationDealInfo.styles';
import { DealStageCellProps } from './cells.props';

const DealStageCell = ({
  valuationRow,
  dealStageOptions,
  dealStageState,
  onDealStageClick,
  onDealStageChange,
  onDealStageEditEnd,
}: DealStageCellProps) => {
  if (valuationRow.is_loading_additional_data) {
    return <Skeleton variant="text" width="80%" height={20} />;
  }

  interface DealStageOptionItem {
    id: string;
    label: string;
  }

  const mappedOptions = dealStageOptions?.map(option => ({
    id: option.id.status_id,
    label: option.title,
  })) || [];
  
  const allDealStageOptions: DealStageOptionItem[] = mappedOptions.toSorted((a, b) => 
    DEAL_PERMITTED_STAGES.indexOf(b.label) - DEAL_PERMITTED_STAGES.indexOf(a.label)
  );

  if (dealStageState === DealStageState.IDLE) {
    return (
      <StyledBadge onClick={onDealStageClick}>
        {valuationRow.deal_stage || 'Deal Stage not set'}
      </StyledBadge>
    );
  }

  if (dealStageState === DealStageState.EDITING) {
    return (
      <StyledAutocomplete
        value={allDealStageOptions.find(option => option.label === valuationRow.deal_stage) || null}
        options={allDealStageOptions}
        getOptionDisabled={option => !DEAL_PERMITTED_STAGES.includes((option as DealStageOptionItem).label)}
        renderInput={params => <TextField {...params} variant="outlined" autoFocus />}
        openOnFocus
        disableClearable
        onChange={(event, value) => {
          onDealStageChange(value as DealStageOptionItem | null);
        }}
        onClose={(_, reason) => {
          if (reason === 'escape') {
            onDealStageEditEnd();
          }
        }}
        renderOption={(props, option) => {
          const typedOption = option as DealStageOptionItem;
          return (
            <li {...props} key={typedOption.id} style={{
              fontSize: '0.875rem',
            }}>
              {typedOption.label}
            </li>
          );
        }}
      />
    );
  }

  if (dealStageState === DealStageState.UPDATING) {
    return <Skeleton variant="text" width="80%" height={20} />;
  }

  return null;
};

export default DealStageCell;

